import axios, { type AxiosResponse } from 'axios';

import Log from '@/Logger';
import { getAccessToken } from '@/auth';


const GRAPHQL_API_URL = import.meta.env.VITE_GRAPHQL_API_URL ?? '';

type Input = {
    [key: string]: Input | Input[] | string | number | boolean
}

type GraphQLBody = any; // resp.config.data の型
type RespBody<T extends string, U> = { data: { [key in T]: U }, errors: any }
type Resp<T extends string, U> = AxiosResponse<RespBody<T, U>, GraphQLBody>


export function mutation<T>(method: 'enabledTenantFeatureSetting', inputType: 'EnabledTenantFeatureSettingtInput', input: Input, output: string[]): Promise<Resp<typeof method, T>>;
export function mutation<T>(method: 'updateDeviceDisplayName', inputType: 'DeviceDisplayNameMappingInput', input: Input, output: string[]): Promise<Resp<typeof method, T>>;

export async function mutation<T>(method: string, inputType: string, input: Input, output: string[]): Promise<Resp<typeof method, T>> {
    const logger = Log.getLogger();

    logger.api.info('Cognito', 'Start to request: currentSession');
    const token = await getAccessToken();
    logger.api.info('Cognito', 'Succeed to request: currentSession');

    const apiResponse = await axios.post<RespBody<typeof method, T>>(
        GRAPHQL_API_URL,
        `{"query": "mutation($input:${inputType}!) { ${method}(input:$input) { ${output.join(', ')} }}", "variables": { "input": ${JSON.stringify(input)} }}`,
        {
            headers: {
                'Content-Type': 'application/graphql',
                'Authorization': `Bearer ${token}`,
            }
        }
    );

    return apiResponse;
}

export function query<T>(method: 'allTenantFeatureSetting', output: string[]): Promise<Resp<typeof method, T>>;
export function query<T>(method: 'tenantDevices', output: string[]): Promise<AxiosResponse<T, GraphQLBody>>;
export function query<T>(method: 'deviceDisplayNames', output: string[]): Promise<AxiosResponse<T, GraphQLBody>>;

export async function query<T>(method: string, output: string[]): Promise<Resp<typeof method, T>> {
    const logger = Log.getLogger();

    logger.api.info('Cognito', 'Start to request: currentSession');
    const token = await getAccessToken();
    logger.api.info('Cognito', 'Succeed to request: currentSession');

    const apiResponse = await axios.post<RespBody<typeof method, T>>(
        GRAPHQL_API_URL,
        `{"query": "query { ${method} { ${output.join(', ')} }}" }`,
        {
            headers: {
                'Content-Type': 'application/graphql',
                'Authorization': `Bearer ${token}`,
            }
        }
    );

    return apiResponse;
}